import { Pagination, paginationToParams } from '../Pagination';

export interface ReviewFilter {
  search?: string;
  userID?: number;
  productID?: number;
  pagination: Pagination;
}

export const reviewFilterToParams = (reviewFilter: ReviewFilter) => ({
  search: reviewFilter.search || undefined,
  'user-id': reviewFilter.userID,
  'product-id': reviewFilter.productID,
  ...paginationToParams(reviewFilter.pagination),
});
